import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { environment } from '../../../environments/environment';
import { Customer } from '../_models/customer';

@Injectable()
export class CustomerService {
  private apiBaseUrl = environment.apiBaseUrl;
  list = [];

  constructor(private http: HttpClient) {}

  getCustomers(): Observable<Customer[]> {
    return this.http.get<Customer[]>(this.apiBaseUrl + 'api/private/v1/customers').pipe(
      map((response) => {
        this.list = response;
        return response;
      })
    );
  }

  getCustomer(id: number): Observable<Customer> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/customers/' + id)
      .pipe(map((response) => response));
  }

  saveCustomer(customerItem): Observable<Customer> {
    const customer = { ...customerItem };
    delete customer.lastUpdated;
    delete customer.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    customer.companyId = companySelected ? companySelected.id : null;

    if (customer.user != null && customer.user.id != null) {
      customer.user = { id: customer.user.id };
    }
    if (customer.id) {
      return this.http
        .put<Customer>(this.apiBaseUrl + 'api/private/v1/customers/' + customer.id, customer)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Customer>(this.apiBaseUrl + 'api/private/v1/customers/', customer)
        .pipe(map((response) => response));
    }
  }

  deleteCustomer(id: number): Observable<Customer> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/customers/' + id).pipe(
      map((response) => {
        return { id } as Customer;
      })
    );
  }

  getLocalCustomerById = (id: number): Customer => {
    let customer: Customer;
    customer = _.find(this.list, (f) => f.id === id);
    return customer;
  };
}
